import { isValid, format } from 'date-fns'

export const DATE_FORMAT_API = 'dd-MMM-yyyy'
// const DATE_FNS_INVALID_DATE_TOKEN = 'Invalid Date'

// const convertDateToMidnightUtc = (d: Date): Date => {
//   return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0))
// }
export const formatDateStringAsApiFormat = (date?: string | null): string | null => {
  if (date === undefined) return null
  if (date === null) return null
  if (date === '') return ''

  const newDate = new Date(date)
  if (isValid(newDate)) {
    return format(newDate, DATE_FORMAT_API)
  } else {
    return date
  }
}
/*
export const parseDateStringAsApiFormat = (date: string | null | undefined): Date | undefined => {
  if (date === undefined) return undefined
  if (date === null) return undefined
  if (date === '') return undefined

  const d = parse(date, DATE_FORMAT_API, new Date())
  if (d.toString() === DATE_FNS_INVALID_DATE_TOKEN) {
    return undefined
  }
  const utc = convertDateToMidnightUtc(d) // new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0))
  return utc
}

 */
